/**
 * Tells the server when this tab is idle, for the yellow "Away" dot colleagues
 * see (server/utils/presence.js).
 *
 * Away after ten minutes without a click, key, scroll or touch here; on a
 * phone, also as soon as the browser goes into the background (the screen is
 * off or another app is in front). A computer's hidden tab only counts once it
 * has been idle that long too: people keep the portal in a tab behind others
 * while they work. Only a change is sent, plus the current state on every
 * (re)connect, since the server starts each new connection as "in use".
 */

export const IDLE_MS = 10 * 60 * 1000;
const CHECK_MS = 30 * 1000;
const ACTIVITY_EVENTS = ['pointerdown', 'keydown', 'wheel', 'touchstart', 'mousemove', 'scroll'];

const isPhone = () => /Mobi|Android|iPhone|iPad/.test(navigator.userAgent || '');

export const trackActivity = (socket) => {
    if (!socket || typeof document === 'undefined') return () => { };

    let lastActive = Date.now();
    let away = null;

    const isAway = () => (
        (document.hidden && isPhone()) || Date.now() - lastActive >= IDLE_MS
    );
    const send = (always = false) => {
        const next = isAway();
        if (!always && next === away) return;
        away = next;
        socket.emit('presence:away', next);
    };

    const onActivity = () => {
        lastActive = Date.now();
        if (away) send();
    };
    const onVisibility = () => {
        if (!document.hidden) lastActive = Date.now();
        send();
    };
    const onConnect = () => send(true);

    ACTIVITY_EVENTS.forEach((e) => window.addEventListener(e, onActivity, { passive: true, capture: true }));
    document.addEventListener('visibilitychange', onVisibility);
    socket.on('connect', onConnect);
    const timer = setInterval(() => send(), CHECK_MS);
    if (socket.connected) send(true);

    return () => {
        ACTIVITY_EVENTS.forEach((e) => window.removeEventListener(e, onActivity, { capture: true }));
        document.removeEventListener('visibilitychange', onVisibility);
        socket.off('connect', onConnect);
        clearInterval(timer);
    };
};
